<template>
  <div>
    <el-carousel height="410px" class="swImg" arrow="never">
      <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
        <img style="height: 100%;" :src="item.img" @click="nav(item)" />
      </el-carousel-item>
    </el-carousel>

    <div class="sidebar">
      <div class="s_left">
        <div class="s_t">
          <div class="ll"></div>
          <div class="lz">学院概况</div>
          <div class="ll"></div>
        </div>
        <div class="lll"></div>
        <div class="ttl">
          <div class="ttl_l"></div>

          <img style="width: 18px;margin-left: 26px;height: 18px;display: block;"
            src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x11.png" alt=""></img>
          <div class="n">学校简介</div>
          <img style="width: 10px;margin-left: 64px;height: 12px;display: block;"
            src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x12.png" alt=""></img>
        </div>
      </div>
      <div class="s_r">
        <div class="s_r_t">
          <div class="z_l">学校简介
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x16.png" alt="">
          </div>
          <div class="zr">
            <img style="width: 14px;height: 14px;margin-right: 4px;"
              src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x13.png" alt="">
            首页 > 学院概况 > 学校简介
          </div>
        </div>
        <div style=" 
      width: 1108px;
        display: flex;align-items: center;margin: 0 auto;">
          <div style="flex:1" class="srl">

          </div>
          <div style="width: 8px;
height: 8px; border-radius: 50%;
border: 1px solid #DDDDDD; "></div>
        </div>

        <div v-html="infoDomain.schoolContent" class="z"></div>
      </div>
    </div>
  </div>
</template>

<script>
 
import { HomeClient } from "@/api/home";
import { getDomain } from '@/api/cookies'
const homeClient = new HomeClient()

export default {
  name: "NewsDynamic",
  data() {
    return {
     
      infoDomain: {},
      imgList: ''
    };
  },
  created() {
    this.infoDomain = getDomain()
    this.getList()

  },
  methods: {
    async getList() {
      await homeClient.getSurfacePcList({ type: 10, entrantsType: this.infoDomain.entrantsType }).then((ress) => {
        if (ress.code == 0) {
          this.imgList = JSON.parse(JSON.stringify(ress.data || []));
        }
      });
    
    },
  }

};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 1400px;
    min-height: 920px;

  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .s_left {
    width: 220px;
    height: 173px;
    background: #1D7DF5;
    border-radius: 0px 0px 0px 0px;
        position: sticky;
    /* 距离顶部 0 像素时固定 */
    top: 90px;
    /* 确保元素显示在其他内容上方 */
    z-index: 9; 

    .s_t {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;

      .ll {
        width: 20px;
        height: 1px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
      }

      .lz {

        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 22px;
        color: #FFFFFF;
        margin: 0 12px;
      }
    }

    .lll {
      width: 219px;
      height: 0px;
      border: 1px solid #64A4F3;
      margin-top: 24px;
    }

    .ttl {
      margin-top: 9px;
      width: 220px;
      height: 54px;
      background: #FFFFFF;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;

      .ttl_l {
        width: 4px;
        height: 54px;
        background: #F3AE55;
        border-radius: 0px 0px 0px 0px;
      }

      .n {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        margin-left: 10px;
      }

    }
  }

  .s_r {
    width: 1170px;
    background: #FFFFFF;

    .s_r_t {
      width: 100%;
      height: 63px;
      display: flex;
      padding: 15px 30px;
      align-items: center;
      justify-content: space-between;

      .z_l {
        position: relative;
        font-family: DingTalk JinBuTi, DingTalk JinBuTi;
        font-weight: 400;
        font-size: 20px;
        color: #1D7DF5;

        img {
          position: absolute;
          width: 29px;
          height: 27px;
          top: 0;
        }
      }

      .zr {

        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        display: flex;
        align-items: center;
      }
    }

    .srl {
      height: 0px;
      border: 1px solid #DDDDDD;
      margin: 0 auto;
    }

    .z {
      padding: 30px;
    }
  }
}

.swImg {
  img {
    width: 100%;
  }

}
</style>
